import React from "react";
import Slider from "react-slick";
import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons";
import "./Styles/Carousel.scss";
import utils from "utils";  
const contentStyle = {
  height: "260px",
  color: "#fff",
  lineHeight: "160px",
  textAlign: "center",
  background: "#364d79",
};
export default class extends React.Component {
  _baseClassName = "tab-carousel-component";
  constructor(props) {
    super(props);
    this.state = {
      props: this.props,
      data: this.props.data || [],
      selected: this.props.selected,
      disabled: this.props.disabled || []
    };
    this.Carousel = React.createRef();
  }
  handleAction(action) {
    if (action == "prev") this.Carousel.current.prev();
    else if (action == "next") this.Carousel.current.next();
  }
  handleTileClick(item, index) {
    if(this.props.formAction){
        utils.Modal(true, {
            width: "650px",
            // closable: false,
            content:
            <div className="finish-Consult-Modal">
            <div className="finish-header">Switch Tab</div>
            <div className="finish-wrapper">
                <div className="finish-title">There are unsaved changes. Are you sure to switch Tab?</div>
                <div className="finish-btns">
                    <button className="action-yes" onClick={() => {  this.setState({selected:index}),utils.Modal(false),  typeof this.props.handleFunction == "function" && this.state.disabled.indexOf(index) == -1 &&  this.props.handleFunction(item, index)}} >Yes</button>
                    <button className="action-no" onClick={() => { utils.Modal(false)} }>No</button>
                </div>
            </div>
        </div>
          })
    }else{
    this.setState({
      selected: index
    }, () => {
      typeof this.props.handleFunction == "function" && this.state.disabled.indexOf(index) == -1 &&  this.props.handleFunction(item, index)
      typeof this.props.disableFunction == "function" && this.state.disabled.indexOf(index) > -1 &&  this.props.disableFunction(item, index)
    });
}
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps !== prevState.props) 
      return { 
        data: nextProps.data,
        selected: nextProps.selected,
        disabled: nextProps.disabled
      };
    else return null;
}

getClassNames(index) {
   
  let baseClass = "carousel-child"
  if(this.state.selected == index && Array.isArray(this.state.disabled) && this.state.disabled.indexOf(index) == -1) return `${baseClass} ${baseClass}-selected`;
  if(this.state.disabled.indexOf(index) > -1) return `${baseClass} ${baseClass}-disabled`
  return baseClass;
}
  render() {
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      
      slidesToShow: 8,
      slidesToScroll: 4,
      nextArrow: <RightCircleOutlined />,
      prevArrow: <LeftCircleOutlined />,
      ...this.props,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
        
          }
        },
        {
          breakpoint: 645,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
 
    //   dots: false,
    //   infinite: false,
    //   speed: 500,
    //   slidesToShow:8,
    //   slidesToScroll: 4,
    //   nextArrow: <RightCircleOutlined />,
    //   prevArrow: <LeftCircleOutlined />,
    //   ...this.props,
    //   responsive: [
    //     {
    //       breakpoint: 1024,
    //       settings: {
    //         slidesToShow: 8,
    //         slidesToScroll: 4,
            
    //       }
    //     },
    //     {
    //       breakpoint: 1080,
    //       settings: {
    //         slidesToShow: 6,
    //         slidesToScroll: 4,
          
    //       }
    //     },
    //     {
    //       breakpoint: 600,
    //       settings: {
    //         slidesToShow: 4,
    //         slidesToScroll: 4,
    //         initialSlide: 2
    //       }
    //     },
    //     {
    //       breakpoint: 480,
    //       settings: {
    //         slidesToShow: 1,
    //         slidesToScroll: 1
    //       }
    //     }
    //   ]
    // };
    return (
      <div className={`${this._baseClassName}-wrapper`}>
        <div className={`${this._baseClassName}-container`}>
          <Slider {...settings} ref={this.Carousel}>
            {(this.state.data || []).map((obj, index) => {      
              return (typeof this.props.render == "function" &&
                <div
                className={this.getClassNames(index)}
                   onClick={e => this.handleTileClick(obj, index)}
                >
                 {this.props.render(obj,index)}
                                  </div> || null)
            })}
          </Slider>
        </div>
      </div>
    );
  }
}




